import LoadingScreen from 'pricing-pages-ui-components/components/LoadingScreen';
import { HubSpotOnCreditsPage } from 'pricing-pages-ui/routes/loadablePages';
import { Redirect, Route, Switch, useLocation } from 'quartz-routing/react-router';
import { HSOC_PRICING_PREVIEW } from './constants/routes';
import { useIsHubSpotOnCredits } from './hooks/useIsHubSpotOnCredits';
import PublicIbRoutes from './PublicIbRoutes';
import PublicHsocPricingPage from './pages/hsoc-pricing/PublicHsocPricingPage';
import { createDeferredLoadable } from './utils/createDeferredLoadable';
import { getUseCasesByPage, useCasesQueryParamKey } from './utils/hsoc';

// Password-gated previews stay out of the main bundle.
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HsocPricingPreviewPage = createDeferredLoadable(() => import( /* webpackChunkName: "hsoc-pricing-preview" */'./pages/hsoc-pricing/HsocPricingPreviewPage').then(m => ({
  default: m.default
})));
export default function PublicRoutes() {
  const {
    isHubSpotOnCreditsV1,
    isHubSpotOnCreditsV2,
    loading: isHSoCPilotLoading
  } = useIsHubSpotOnCredits();
  const {
    pathname
  } = useLocation();

  // Experimental preview: reveal the existing HSOC page behind a client-side
  // password gate, independent of the region pilot flag. Matched before the
  // pilot loading/branching below so it works regardless of viewer region.
  if (pathname === `/${HSOC_PRICING_PREVIEW}`) {
    return /*#__PURE__*/_jsx(HsocPricingPreviewPage, {});
  }
  if (isHSoCPilotLoading) {
    return /*#__PURE__*/_jsx(LoadingScreen, {});
  }

  // HSOC V1: full-width experience, no sidenav layout.
  if (isHubSpotOnCreditsV1) {
    return /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/",
        exact: true,
        component: HubSpotOnCreditsPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/:page",
        render: ({
          location,
          match: {
            params: {
              page
            }
          }
        }) => {
          const searchParams = new URLSearchParams(location.search);
          const useCases = getUseCasesByPage(page);
          for (const useCase of useCases) {
            searchParams.append(useCasesQueryParamKey, useCase);
          }
          return /*#__PURE__*/_jsx(Redirect, {
            to: Object.assign({}, location, {
              search: searchParams.toString(),
              pathname: '/'
            })
          });
        }
      })]
    });
  }

  // HSOC V2: full-width experience, no sidenav layout.
  if (isHubSpotOnCreditsV2) {
    return /*#__PURE__*/_jsxs(Switch, {
      children: [/*#__PURE__*/_jsx(Route, {
        path: "/",
        exact: true,
        component: PublicHsocPricingPage
      }), /*#__PURE__*/_jsx(Route, {
        path: "/:page",
        render: ({
          location
        }) => /*#__PURE__*/_jsx(Redirect, {
          to: Object.assign({}, location, {
            pathname: '/'
          })
        })
      })]
    });
  }
  return /*#__PURE__*/_jsx(PublicIbRoutes, {});
}